import SvgChevronDown from '../../svg/icons/ChevronDown'

export function Chevron(props: { direction: 'right' | 'down' }) {
	return (
		<span
			style={{
				display: 'inline-flex',
				width: '1em',
				height: '1em',
				alignItems: 'center',
				justifyContent: 'center',
				verticalAlign: 'middle',
				transform: props.direction === 'down' ? undefined : 'rotate(-90deg)',
				fontSize: '.66em',
				transition: 'transform ease-in-out .2s',
			}}
		>
			<SvgChevronDown />
		</span>
	)
}
